import React from 'react'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

export const CarouselComp = ({ platform = 'ios' }) => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 0 },
            items: 1
        },
    };
    const imgStyle = {
        width: '100%',
        maxWidth: '230px',
        height: 'auto',
    }

    return (
        <div className='p-2 bg-[#1e2027] rounded-lg' >
            <Carousel responsive={responsive}
                showDots={false}
                centerMode={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={2000}
            >
                <div>
                    <img src={require(`../../assets/images/${platform}/carousel-1.png`)} style={imgStyle} alt='sekabet screenshot 1' />
                </div>
                <div>
                    <img src={require(`../../assets/images/${platform}/carousel-2.png`)} style={imgStyle} alt='sekabet screenshot 2' />
                </div>
                <div>
                    <img src={require(`../../assets/images/${platform}/carousel-3.png`)} style={imgStyle} alt='sekabet screenshot 3' />
                </div>
                <div>
                    <img src={require(`../../assets/images/${platform}/carousel-4.png`)} style={imgStyle} alt='sekabet screenshot 4' />
                </div>
                <div>
                    <img src={require(`../../assets/images/${platform}/carousel-5.png`)} style={imgStyle} alt='sekabet screenshot 5' />
                </div>
            </Carousel>
        </div>
    )
}
